import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=2ed3bcc8&scoped=true"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=2ed3bcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed3bcc8",
  null
  
)

export default component.exports